import { useState } from "react";

import { makeGetApiCall, makePostApiCall } from "../../../shared/makeApiCall";
import ModelErrorComponent from "../../../components/modals/ModelErrorComponent";
import { SnackbarData, SnackbarType } from "../../../components/Snackbar";
import { generateUniqueNumber } from "../../../shared/utility";

export function CustomerDetailsViewModel(logout, id, addSnackbar) {
  const [loading, setLoading] = useState(false);
  const [customer, setCustomer] = useState({
    name: "",
  });
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });

  const showErrorModal = (title, subtitle) => {
    setEmptyModelOpen({
      childComponent: (
        <ModelErrorComponent
          setOpen={setEmptyModelOpen}
          subtitle={subtitle}
          title={title}
        />
      ),
      open: true,
    });
  };

  const getCustomer = async function (search, page) {
    setLoading(true);

    let callResult = await makeGetApiCall(`customers/${id}`);
    setLoading(false);
    if (callResult.success) {
      setCustomer(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
  };

  const updateCustomer = async function (values, index) {
    let callResult = await makePostApiCall(
      `customers/${values.id}`,
      values,
      "multipart/form-data"
    );

    if (callResult.success) {
      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          callResult.data.message,
          SnackbarType.Success
        )
      );
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
  };

  return {
    customer,
    getCustomer,
    loading,
    setEmptyModelOpen,
    emptyModal,
    updateCustomer,
  };
}
